import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import PsychometricService from '../../services/PsychometricService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';
import PsychometricTestMainNavbar from './PsychometricTestMainNavbar';
const PsychometricOrganizationSignUp = props => {
    // contexts
    const { theme, fontFamily, fontSize, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [organization, setOrganization] = useState({
        name: "",
        email: "",
        mobile: "",
        address: "",
        city: "",
        state: "",
        country: "",
        website: "",
        password: "",
        confirmPassword: "",
       
    });
    const [dateBeforeYears, setDateBeforeYears] = useState(moment());
    const [minimumAge, setMinimumAge] = useState(0);
    const [message, setMessage] = useState({ msgBody: '', msgError: false });
    const [isLoading, setIsLoading] = useState(false);
    let timerID = useRef(null);

    const history = useHistory(); // Initialize useHistory for navigation



    useEffect(() => {
        window.scrollTo(0, 0);
    }, [message]);

    // Utility functions
    // reset form 
    const resetForm = () => {
        try {
            setOrganization({
                name: "",
                email: "",
                mobile: "",
                address: "",
                city: "",
                state: "",
                country: "",
                website: "",
                password: "",
                confirmPassword:"",
          
            });
        } catch (err) {
            Alert.error("Some error occurred, please try again later or report to the support team.");
            GeneralService.logError('at Organization SignUp resetForm', 'Error in try catch block', err.stack);
        }
    }

    // handle functions
    const handleChange = e => {
        try {
            setOrganization({ ...organization, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occurred, please try again later or report to the support team.");
            GeneralService.logError('at Organization SignUp handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Perform client-side validation
            if (organization.password !== organization.confirmPassword) {
                setMessage({
                    msgBody: "Passwords don't match",
                    msgError: true
                });
                return;
            }
      
            // Call createOrganization function
            await PsychometricService.signUpOrganization(
                organization.name,
                organization.email,
                organization.mobile,
                organization.address,
                organization.city,
                organization.state,
                organization.country,
                organization.website,
                organization.password
            );

            resetForm();
            setMessage({
                msgBody: "Sign-up successful! Please check your email to verify your account before signing in.",
                msgError: false
            });

            // Pass the verification message through navigation state
            history.push({
                pathname: '/psychometricManagementPortal',
                state: { verificationMessage: "Please check your email to verify your account before signing in." }
            });
            
        } catch (err) {
            // Display the server's error message if it exists
            setMessage(
                err.message || {
                    msgBody: "Sign-up failed. Please try again.",
                    msgError: true
                }
            );
        }
    };

  
    return (
        <div>
            <ErrorBoundary errorAt="At Organization SignUp GeneralNavbar">
                <PsychometricTestMainNavbar history={props.history} />
            </ErrorBoundary>
            <div className="col-md-6 py-5 offset-md-3">
                <div className="p-3" style={theme.form}>
                    <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                        <h2 id="sign-up-heading" style={theme.heading}>Organisation Sign Up</h2>
                        <br />

                        <ErrorBoundary errorAt="At Organization SignUp Message">
                            {message.msgBody ? <Message message={message} /> : null}
                        </ErrorBoundary>

                        <ErrorBoundary errorAt="At Organization SignUp FormFields">
                            {/* Name */}
                            <label htmlFor="name" style={theme.formBodyText}>Organisation Name</label>
                            <input type="text" id="form-input-name" name="name" value={organization.name} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Email */}
                            <label htmlFor="email" style={theme.formBodyText}>Email</label>
                            <input type="email" id="form-input-email" name="email" value={organization.email} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Mobile */}
                            <label htmlFor="mobile" style={theme.formBodyText}>Mobile</label>
                            <input type="tel" id="form-input-mobile" name="mobile" value={organization.mobile} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Address */}
                            <label htmlFor="address" style={theme.formBodyText}>Address Line</label>
                            <input type="text" id="form-input-address" name="address" value={organization.address} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* City */}
                            <label htmlFor="city" style={theme.formBodyText}>City</label>
                            <input type="text" id="form-input-city" name="city" value={organization.city} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* State */}
                            <label htmlFor="state" style={theme.formBodyText}>State</label>
                            <input type="text" id="form-input-state" name="state" value={organization.state} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Country */}
                            <label htmlFor="country" style={theme.formBodyText}>Country</label>
                            <input type="text" id="form-input-country" name="country" value={organization.country} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Website */}
                            <label htmlFor="website" style={theme.formBodyText}>Website</label>
                            <input type="text" id="form-input-website" name="website" value={organization.website} onChange={handleChange} className="form-control" style={theme.formInput} />
                            <br />

                            {/* Password */}
                            <label htmlFor="password" style={theme.formBodyText}>Password</label>
                            <input type="password" id="form-input-password" name="password" value={organization.password} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />

                            {/* Confirm Password */}
                            <label htmlFor="confirmPassword" style={theme.formBodyText}>Confirm Password</label>
                            <input type="password" id="form-input-confirmPassword" name="confirmPassword" value={organization.confirmPassword} onChange={handleChange} className="form-control" required style={theme.formInput} />
                            <br />
                        </ErrorBoundary>

                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*Password must have at least 6 characters with one alphabet, one digit and one uppercase</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*After sign up, a verification email will be sent to your email address</p>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*By clicking on Sign Up button below, you agree to our <Link to='/termsconditions'><u>Terms &#38; Conditions</u></Link>, <Link to='/privacypolicy'><u>Privacy Policy</u></Link> and <Link to='/cookiepolicy'><u>Cookie Policy</u></Link></p>
                        <br />
                        <div className="row">
                            <button type="submit" className="btn btn-primary btn-lg mx-auto" style={theme.formSubmit}>Sign Up</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PsychometricOrganizationSignUp;
